'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
var Icon = require('../Icon/Icon.js');
var Loader = require('../Loader/Loader.js');
require('./Button.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PlainButton = function (_a) {
    var size = _a.size, variant = _a.variant; _a.type; var onClick = _a.onClick, disabled = _a.disabled, className = _a.className; _a.hasIcon; var isBlock = _a.isBlock, isLoading = _a.isLoading, children = _a.children, loaderColor = _a.loaderColor, props = tslib_es6.__rest(_a, ["size", "variant", "type", "onClick", "disabled", "className", "hasIcon", "isBlock", "isLoading", "children", "loaderColor"]);
    return (React__default['default'].createElement("button", tslib_es6.__assign({ className: index['default']('heading-sm-r', [size && "lp-button-" + size,
            variant && "lp-button-" + variant,
            className && "" + className,
            isBlock && "lp-button-block", isLoading && 'lp-button-loading',]), onClick: function (event) { return onClick(event); }, disabled: (disabled || isLoading) ? true : false }, props),
        children,
        isLoading ? React__default['default'].createElement(Loader.Loader, { loaderColor: loaderColor, size: size, spaceBtwText: "30px" }) : React__default['default'].createElement(React__default['default'].Fragment, null)));
};
var Button = function (_a) {
    var size = _a.size, variant = _a.variant, type = _a.type, onClick = _a.onClick, disabled = _a.disabled, className = _a.className, hasIcon = _a.hasIcon, children = _a.children, props = tslib_es6.__rest(_a, ["size", "variant", "type", "onClick", "disabled", "className", "hasIcon", "children"]);
    if (hasIcon) {
        return (React__default['default'].createElement(React__default['default'].Fragment, null,
            React__default['default'].createElement(Icon.Icon, { variant: variant, tabIndex: 1, onClick: function (event) { return onClick(event); }, disabled: disabled })));
    }
    return (React__default['default'].createElement(React__default['default'].Fragment, null, PlainButton(tslib_es6.__assign({ size: size,
        variant: variant,
        type: type,
        onClick: onClick,
        disabled: disabled,
        className: className,
        hasIcon: hasIcon,
        children: children }, props))));
};

exports.Button = Button;
//# sourceMappingURL=Button.js.map
